import { SCRAP_UNIT_PRICE } from '~/constants';

import type { TypeReturnDisposalIssueItemApi } from '~/types/receive.types';

/** 소수 셋째 자리에서 반올림 → 둘째 자리까지 (부동소수 보정) */
const roundTo2 = (value: number): number => Math.round((value + Number.EPSILON) * 100) / 100;

/**
 * 카드별 폐기중량(kg) — weightKg(net_weight, kg 단위) × 이슈수량, 소수 셋째 자리 반올림
 */
export const getScrapWeightKg = (weightKg: number, issueQty: number): number =>
  roundTo2((weightKg || 0) * (issueQty || 0));

/** 선택 이슈카드 전체의 총 폐기중량(kg) — Σ 카드별 폐기중량 */
export const getTotalScrapWeightKg = (items: TypeReturnDisposalIssueItemApi[]): number =>
  roundTo2(items.reduce((sum, item) => sum + getScrapWeightKg(item.weightKg, item.issueQty), 0));

/** 폐기비용(원) — 총 폐기중량(kg) × 480원, 소수점 이하 버림 */
export const getScrapFee = (totalWeightKg: number): number => Math.floor(totalWeightKg * SCRAP_UNIT_PRICE);
